import { useId } from 'react';

const IconCharCount = () => {
  const id = useId();
  const clipId = `clip-${id}`;
  const maskId = `mask-${id}`;
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='150'
      height='150'
      fill='none'
      viewBox='0 0 150 150'>
      <g clipPath={`url(#${clipId})`}>
        <mask
          id={maskId}
          width='150'
          height='150'
          x='0'
          y='0'
          maskUnits='userSpaceOnUse'
          style={{ maskType: 'luminance' }}>
          <path fill='#fff' d='M150 150V0H0v150h150Z' />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            fill='#DEBAFC'
            fillRule='evenodd'
            d='M113.25 0v21h.004c.2 8.732 7.341 15.75 16.121 15.75H150v4.5h-21c-8.699 0-15.75 7.051-15.75 15.75 0 8.698 7.051 15.75 15.75 15.75h21v4.5h-21c-8.699 0-15.75 7.052-15.75 15.75 0 8.699 7.051 15.75 15.75 15.75h21V114h-21c-8.699 0-15.75 7.052-15.75 15.75V150h-4.5v-21c0-8.698-7.052-15.75-15.75-15.75S77.25 120.302 77.25 129v21h-4.5v-21c0-8.698-7.052-15.75-15.75-15.75-8.699 0-15.75 7.052-15.75 15.75v21h-4.5v-20.25c0-8.698-7.052-15.75-15.75-15.75H0v-5.25h21c8.698 0 15.75-7.051 15.75-15.75 0-8.698-7.052-15.75-15.75-15.75H0v-4.5h21c8.698 0 15.75-7.052 15.75-15.75 0-8.699-7.052-15.75-15.75-15.75H0v-4.5h20.625c8.78 0 15.922-7.018 16.12-15.75h.005V0h4.5v21c0 8.698 7.051 15.75 15.75 15.75 8.698 0 15.75-7.052 15.75-15.75V0h4.5v21c0 8.698 7.052 15.75 15.75 15.75s15.75-7.052 15.75-15.75V0h4.5Zm-36 57c0 8.698 7.052 15.75 15.75 15.75s15.75-7.052 15.75-15.75c0-8.699-7.052-15.75-15.75-15.75S77.25 48.301 77.25 57Zm0 36c0 8.699 7.052 15.75 15.75 15.75s15.75-7.051 15.75-15.75c0-8.698-7.052-15.75-15.75-15.75S77.25 84.302 77.25 93ZM57 72.75c-8.699 0-15.75-7.052-15.75-15.75 0-8.699 7.051-15.75 15.75-15.75 8.698 0 15.75 7.051 15.75 15.75 0 8.698-7.052 15.75-15.75 15.75ZM41.25 93c0 8.699 7.051 15.75 15.75 15.75 8.698 0 15.75-7.051 15.75-15.75 0-8.698-7.052-15.75-15.75-15.75-8.699 0-15.75 7.052-15.75 15.75Z'
            clipRule='evenodd'
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <path fill='#fff' d='M150 0v150H0V0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconCharCount;
